import { render, staticRenderFns } from "./StepPertussisPregnancy2.vue?vue&type=template&id=75c40f2b&"
import script from "./StepPertussisPregnancy2.vue?vue&type=script&lang=js&"
export * from "./StepPertussisPregnancy2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports